import React, { useState, useRef, } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
const Imgcroper = () => {
    const [crop, setCrop] = useState({
        unit: '%',
        x: 25,
        y: 25,
        width: 50,
        height: 50,
    });
    const [image, setImage] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const fileInputRef = useRef(null);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImage(e?.target?.result);
            };
            reader.readAsDataURL(e?.target?.files[0]);
        }
    };
    const onCropComplete = (crop) => {
        makeClientCrop(crop);
    };
    const makeClientCrop = async (crop) => {
        if (image && crop?.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(image, crop);
            setCroppedImage(croppedImageUrl);
        }
    };
    // to convert Base64
    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         // reader.onloadend = () => {
    //         //     const base64Image = reader.result;
    //         //     setProfileAllData({
    //         //         ...profileAlldata,
    //         //         UrlLink: base64Image,
    //         //     });
    //         //     setNewImageUrl(base64Image);
    //         // };
    //         reader.readAsDataURL(file);
    //         // Extract file extension
    //         const photoExtension = file.type.split("/")[1];
    //         // setPhotoExtension(photoExtension);
    //     }
    // };
    const getCroppedImg = (image, crop) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const scaleX = img?.naturalWidth / img.width;
                const scaleY = img?.naturalHeight / img.height;
                canvas.width = crop.width;
                canvas.height = crop.height;
                ctx.drawImage(
                    img,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );
                canvas?.toBlob((blob) => {
                    const croppedImageUrl = URL.createObjectURL(blob);
                    resolve(croppedImageUrl);
                }, 'image/jpeg');

            };
        });
    };
    const handleYesClick = () => {
        setIsConfirmed(true);
        setImage(null)
    };
    const handleNoClick = () => {
        setImage(null);
        setIsConfirmed(false);
        setCroppedImage(null)
    };

    return (
        <div>
            <input
                type="file"
                ref={fileInputRef}
                onChange={(e) => {
                    onSelectFile(e);
                }}
                style={{ display: 'none' }}
            />
            <button onClick={() => fileInputRef.current.click()}>Choose Image</button>
            {image && ( 
                <ReactCrop crop={crop} onChange={(c) => setCrop(c)} onComplete={onCropComplete}>
                    <img style={{ width: '100%' }} src={image} alt="crop-preview" />
                </ReactCrop>
            )}
            {croppedImage && (
                <div style={{ width: '10%' }}>
                    <h2>Cropped Image </h2>
                    <img src={croppedImage} alt="cropped" />
                </div>
            )}
            {image && !isConfirmed && (
                <div>
                    <button onClick={handleYesClick}>Yes</button>
                    <button onClick={handleNoClick}>No</button>
                </div>
            )}
        </div>
    );
};
export default Imgcroper;